import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  [
    'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md',
    'font-geist text-[11px] font-medium leading-none',
    'border',
  ],
  {
    variants: {
      variant: {
        default: 'bg-fd-surface-2 text-fd-text-muted border-fd-border',
        accent:  'bg-fd-accent text-fd-text border-fd-text',
        ok:      'bg-[oklch(0.74_0.14_145/0.14)] text-fd-ok border-[oklch(0.74_0.14_145/0.30)]',
        warn:    'bg-[oklch(0.78_0.13_65/0.14)] text-fd-warn border-[oklch(0.78_0.13_65/0.30)]',
        bad:     'bg-[oklch(0.66_0.21_25/0.14)] text-fd-bad border-[oklch(0.66_0.21_25/0.30)]',
        outline: 'bg-transparent text-fd-text-muted border-fd-border',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
